import React, { useMemo, memo } from 'react';
import BasicEchart from '../BasicEchart';
import { isEqual } from 'lodash-es';
import { BASE_ECHART_OPTION } from '@gp/constants/echarts';
import '../../index.scss';

function BarEchart(props: any) {
  const {
    type = 'bar',
    refresh, // 这个值一定是变化的, 变化了echart就会刷新渲染
    options = {},
    fontSize,
    xAxisData,
    seriesData = [],
    tootipFormatter = null,
    axisPointerType,
    ...rest
  } = props;

  const tooltipPosition = (
    point: any,
    params: any,
    dom: any,
    rect: any,
    size: any,
  ) => {
    let x = 0; // x坐标位置
    let y = 0; // y坐标位置
    // 当前鼠标位置
    let pointX = point[0];
    let pointY = point[1];
    // 提示框大小
    let boxWidth = size.contentSize[0];
    let boxHeight = size.contentSize[1];
    // boxWidth > pointX 说明鼠标左边放不下提示框
    if (boxWidth > pointX) {
      x = pointX + 10;
    } else {
      // 左边放的下
      x = pointX - boxWidth - 10;
    }

    // boxHeight > pointY 说明鼠标上边放不下提示框
    if (boxHeight > pointY) {
      y = 5;
    } else {
      // 上边放得下
      y = pointY - boxHeight;
    }
    return [x, y];
  };
  const option = useMemo(() => {
    return {...{
      //init 初始化echart option
      textStyle: {
        fontSize: fontSize || 12,
      },
      grid: {
        left: '30px',
        top: '20px',
        right: '0px',
        bottom: '20px',
      },
      xAxis: {
        ...BASE_ECHART_OPTION.xAxis,
        axisTick: {
          show: false, //不显示Y轴刻度尺
        },
        axisLabel: {
          // 不用写入textStyle对象里面，会echart报黄色提示
          color: 'rgb(0,0,0)',
          fontSize: fontSize || 12,
        },
        data: xAxisData,
      },
      tooltip: {
        ...BASE_ECHART_OPTION.tooltip,
        // show: true,
        // showContent: true,
        // alwaysShowContent: true,
        borderWidth: 0,
        backgroundColor: 'rgba(255, 255, 255, 0)',
        className: `echarts-tooltip-custom-style ${fontSize === 14 ? 'font14' : ''}`,
        trigger: 'axis',
        enterable: false, // 鼠标可进入提示框浮层中
        // showDelay: 5, // 显示延迟，添加显示延迟可以避免频繁切换，单位ms
        // hideDelay: 150, // 浮层隐藏的延迟，单位ms
        axisPointer: {
          ...BASE_ECHART_OPTION?.tooltip?.axisPointer,
          // 坐标轴指示器，坐标轴触发有效
          type: axisPointerType || 'shadow',
          lineStyle: {
            //鼠标移入时候的样式
            color: {
              colorStops: [
                {
                  offset: 0,
                  color: 'rgba(187, 187, 187, 0.2)', // 100% 处的颜色
                },
              ],
            },
            type: 'solid',
            width: (axisPointerType === 'shadow' || !axisPointerType) ? 96 : undefined, //阴影宽度
          },
        },
        formatter: tootipFormatter,
        position: tooltipPosition,
      },
      yAxis: [
        {
          type: 'value',
          axisLabel: {
            fontSize: fontSize || 12,
          },
        },
      ],
      series: [
        {
          type,
          barWidth: 46,
          backgroundStyle: {
            color: 'rgba(0,0,0)',
          },
          itemStyle: {
            color: '#588CF3',
            opacity: 0.95,
          },
          label: {
            show: true,
            position: 'top',
            color: '#000',
            fontFamily: 'PingFang SC',
            opacity: 0.45,
            // fontSize: '12px',
            fontWeight: 400,
          },
          data: seriesData,
        },
      ],
    }, ...options};
  }, [xAxisData, seriesData, options]);

  return (
    <BasicEchart
      refresh={refresh}
      options={option}
      {...rest}
    />
  );
}

function areEqual(prevProps: any, nextProps: any) {
  return isEqual(prevProps, nextProps);
}

export default memo(BarEchart, areEqual);
